<svg
    width="9"
    height="16"
    viewBox="0 0 9 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g clip-path="url(#clip0_18_6494)">
        <path
            d="M1 1L8 8L1 15"
            stroke="#3C3C3C"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </g>
</svg>
